import CrowdfundingShare, { I18N_CONTEXT } from './crowdfunding_share'
import { connect } from 'react-redux'
import { createRemotely } from 'redux/modules/campaign'
import { campaignUrlWithMeDomain } from 'lib/campaign_url'
import {
  getCampaignSelector,
  getLastCreatedCampaignSelector,
} from 'redux/selectors/campaign'
import preventNavigation from 'components/common/prevent_navigation'
import { formatDateShort, formatMoney } from 'client/griffin'
import { getI18n } from 'client/i18n'
import _get from 'lodash/get'

const i18n = getI18n(I18N_CONTEXT)

const mapStateToProps = (state, props) => {
  const lastCreatedCampaign = getLastCreatedCampaignSelector(state)
  const campaign = lastCreatedCampaign || getCampaignSelector(state, props)
  const campaignId = campaign.id
  const urlWithMeDomain = campaignUrlWithMeDomain(campaign.id)
  const shareMessage = i18n('share_message', {
    goalAmount: formatMoney(campaign.currency, campaign.goal, {
      removeTrailingZeros: true,
    }),
    expiryDate: formatDateShort(campaign.end_date),
    shareUrl: urlWithMeDomain,
    campaignTitle: campaign.title,
  })
  const shareDescription = _get(shareMessage, 'props.children', shareMessage)

  return {
    campaignId,
    charity: campaign.charity,
    operatingRemotely: campaign.operatingRemotely,
    poolUrl: urlWithMeDomain,
    creationError: campaign.err,
    shareDescription,
    paypalDomain: state.geo.paypalDomain,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onPublish() {
      dispatch(createRemotely(campaignId))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(preventNavigation(CrowdfundingShare, props => props.operatingRemotely))
